import {
  CheckCircleRoundedIcon,
  ErrorRoundedIcon,
  InfoRoundedIcon,
  WarningRoundedIcon,
} from '../../icons';
import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          success: <CheckCircleRoundedIcon />,
          error: <ErrorRoundedIcon />,
          info: <InfoRoundedIcon />,
          warning: <WarningRoundedIcon />,
          muted: <InfoRoundedIcon />,
        },
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme }, ownerState }) => {
          const color = ownerState?.severity ?? 'success';

          const COLOR_MAPPING = {
            success: {
              textColor: theme.palette.success.darker,
              backgroundColor: theme.palette.success.lighter,
            },
            error: {
              textColor: theme.palette.error.darker,
              backgroundColor: theme.palette.error.lighter,
            },
            info: {
              textColor: theme.palette.info.darker,
              backgroundColor: theme.palette.info.lighter,
            },
            warning: {
              textColor: theme.palette.warning.darker,
              backgroundColor: theme.palette.warning.lighter,
            },
            muted: {
              textColor: theme.palette.text.primary,
              backgroundColor: theme.palette.grey[100],
            },
          };

          const { textColor, backgroundColor } = COLOR_MAPPING[color];

          return sx({
            boxSizing: 'border-box',
            alignItems: 'center',
            borderRadius: theme.shape.rounded(2),
            color: textColor,
            backgroundColor,
            ...theme.typography.body1Semibold,
          });
        },
        standard: ({ theme: { unstable_sx: sx } }) => sx({ p: 2 }),
        outlined: ({ theme: { unstable_sx: sx, ...theme }, ownerState }) => {
          const color = ownerState?.severity ?? 'success';

          const BORDER_COLOR = {
            success: theme.palette.success.main,
            error: theme.palette.error.main,
            info: theme.palette.info.main,
            warning: theme.palette.warning.main,
            muted: theme.palette.grey[500],
          };

          const borderColor = BORDER_COLOR[color];

          // Note: Padding top & bottom -1 because calculate border too. (current border 1px)
          return sx({
            padding: '15px',
            border: '1px solid',
            borderColor,
          });
        },
        // Alert with `variant="filled" is intended to be used with Snackbar component`
        filled: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            bgcolor: theme.palette.grey[800],
            color: theme.palette.common.white,
            p: 2,
          }),
        icon: ({ theme: { unstable_sx: sx, ...theme }, ownerState }) => {
          const color = ownerState?.severity ?? 'success';

          const ICON_COLOR = {
            success: theme.palette.success.main,
            error: theme.palette.error.main,
            info: theme.palette.info.main,
            warning: theme.palette.warning.main,
            muted: theme.palette.grey[600],
          };

          const iconColor = ICON_COLOR[color];

          return sx({
            padding: 0,
            alignItems: 'center',
            fontSize: '24px',
            '.MuiSvgIcon-root': {
              fontSize: 'inherit',
              color: iconColor,
            },
          });
        },
        action: ({ theme: { unstable_sx: sx } }) => sx({ p: 0, alignItems: 'center' }),
        message: ({ theme: { unstable_sx: sx } }) => sx({ p: 0 }),
      },
    },
  },
});

export default theme.components;
